/* HDD 渲染劵会员购买成功弹框 */
import { useEffect } from 'react';
import {} from 'antd';
import {} from '@ant-design/icons';
import {} from '&/utils/common';
import BuySuccess from '&/pages/rendering-voucher/components/buySuccess';
import closeIcon from '@/assets/img/hdd/renderingCoupons/closeIcon.png';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

export default function BugSuccessModal(props) {
    const { location } = props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const member = params.get('member');
    usePreventDefault();
    console.log(
        '成功页面wrap参数------->>>',
        decodeURI(window.location.search)
    );
    let timer;

    const [memberData, setMemberData] = useState({});
    const [userInfo, setUserInfo] = useState({});
    const [timeCount, setTimeCount] = useState(5);

    useEffect(() => {
        init();
        let num = timeCount;
        timer = setInterval(() => {
            num -= 1;
            setTimeCount(num);
            if (num === 0) {
                clearTimer();
                hide();
            }
        }, 1000);
        return clearTimer;
    }, []);

    const init = () => {
        const userInfoData = JSON.parse(localStorage.getItem('HDDUserData'));
        if (token) {
            if (member) {
                const data = JSON.parse(member);
                setMemberData(data);
            }
            setUserInfo(userInfoData);
        }
    };
    const hide = () => {
        try {
            const userInfoData = JSON.parse(
                localStorage.getItem('HDDUserData')
            );
            const sendData = {
                expire: '',
                rememberMe: '',
                token,
                userinfo: { ...userInfoData, enterpriseId: '' },
            };
            window.external.DispatchFun(
                'StartPage',
                'UpdateLoginStatus',
                JSON.stringify(sendData)
            );
            window.external.DispatchFun('StartPage', 'CloseRender', '');
        } catch (e) {}
    };
    const clearTimer = () => {
        if (!timer) return;
        clearInterval(timer);
        timer = undefined;
        setTimeCount(5);
    };

    return (
        <div className="bug-success-modal">
            <div className="header">
                <img
                    className="close-btn"
                    onClick={hide}
                    src={closeIcon}
                    alt=""
                />
            </div>
            <BuySuccess
                userInfo={userInfo}
                memberData={memberData}
                hide={hide}
            />
        </div>
    );
}
